import { PeopleTeamRegular, PersonInfoRegular } from '@fluentui/react-icons';
export const teamsModule = {
    path: 'teams',
    title: 'Teams',
    icon: PeopleTeamRegular,
    placement: 'footer',
    pages: [
        {
            path: 'usuario',
            title: 'Usuário',
            description: 'O que o Teams e o Entra ID dizem de você, sem pedir permissões novas.',
            icon: PersonInfoRegular,
            // Diagnóstico para quem administra: mostra ids do tenant e do app.
            permission: 'TeamsUser.Read',
            load: () => import('#src/modules/teams/TeamsUserPage.js').then((m) => m.TeamsUserPage),
        },
    ],
};
//# sourceMappingURL=teams.module.js.map